module.exports = __webpack_public_path__ + "img/238.compressor_rails.81d06d06.svg";